import { configureStore } from "@reduxjs/toolkit";
import auth from "./slices/authSlice";
import vehicle from './slices/vehicleSlice';
import notifications from './slices/notificationSlice';
import { useDispatch, useSelector } from "react-redux";
import configureMiddleware from './middleware';
import baseApi from "../services/apis/setup/baseApi";

const middleware = configureMiddleware();

const store = configureStore({
  reducer: {
    auth: auth,
    vehicle: vehicle.reducer,
    notifications: notifications,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
})

export default store;

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector: <TSelected>(selector: (state: RootState) => TSelected) => TSelected = useSelector;
export type RootState = ReturnType<typeof store.getState>